/**
 * Created by flj on 2019/3/6 .
 */
import React, { Component, PureComponent } from 'react';
import './index.less';
import zuolinLogo from 'images/zl-logo.png';
class HeaderWithLogo extends (PureComponent || Component) {
	render () {
		const {type, title} = this.props;
		const prefixCls = type ? 'eh-header-with-logo-sm' : 'eh-header-with-logo';

		return (
			<div className={prefixCls}>
				<div className={`${prefixCls}-innerbox`}>
					<div className={`${prefixCls}-logo`} style={this.props.style}>
						<div className={`${prefixCls}-logo-img`}>
							<img src={zuolinLogo} />
						</div>
						<div className={`${prefixCls}-logo-text`}>
							<span className={`${prefixCls}-logo-text-centre`}></span>
							<span className={`${prefixCls}-logo-text-right`}>
								{title || '商户平台'}
							</span>
						</div>
					</div>
					<div className={`${prefixCls}-contain`}>
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

export default HeaderWithLogo;
